export default __webpack_public_path__ + "static/media/method.4b494ce7.png";